'use client';

import { c as _c } from "react/compiler-runtime";
import gsap from 'gsap';
import { useLayoutEffect } from 'react';
import Tempus from 'tempus';
import { ScrollTriggerConfig } from './scroll-trigger';
export function GSAP(t0) {
  const $ = _c(3);
  const {
    scrollTrigger: t1
  } = t0;
  const scrollTrigger = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useLayoutEffect(_temp3, t2);
  let t3;
  if ($[1] !== scrollTrigger) {
    t3 = scrollTrigger && <ScrollTriggerConfig />;
    $[1] = scrollTrigger;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}

// Detect low performance devices to automatically optimize
function _temp3() {
  gsap.defaults({
    ease: "none",
    overwrite: "auto",
    lazy: true
  });
  gsap.ticker.lagSmoothing(0);
  gsap.ticker.remove(gsap.updateRoot);
  if (detectLowPerformanceDevice()) {
    gsap.ticker.fps(30);
    gsap.globalTimeline.timeScale(0.8);
  } else {
    gsap.ticker.fps(60);
  }
  Tempus?.add(_temp);
  const handleVisibilityChange = _temp2;
  document.addEventListener("visibilitychange", handleVisibilityChange);
  return () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}
function _temp2() {
  if (document.hidden) {
    gsap.globalTimeline.pause();
  } else {
    gsap.globalTimeline.resume();
  }
}
function _temp(time) {
  gsap.updateRoot(time / 1000);
}
function detectLowPerformanceDevice() {
  // Skip in SSR
  if (typeof window === 'undefined') return false;

  // Check for mobile devices
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  // Check for low memory devices
  const hasLowMemory = !!(
  // @ts-ignore - Non-standard but useful API
  navigator.deviceMemory && navigator.deviceMemory < 4);

  // Check hardware concurrency (processor cores)
  const hasLowCPU = !!(navigator.hardwareConcurrency && navigator.hardwareConcurrency < 4);

  // Run quick performance test
  const startTime = performance.now();
  for (let i = 0; i < 10000; i++) {
    Math.sqrt(Math.random() * 10000);
  }
  const endTime = performance.now();
  const isSlowCPU = endTime - startTime > 10; // More than 10ms suggests a slower CPU

  return isMobile && (hasLowMemory || hasLowCPU) || isSlowCPU;
}